import api from './api'

const employeeTitleService = {
  // Get all employee titles
  async getEmployeeTitles(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await api.get('/admin/employee-titles', { params })
      return response
    } catch (error) {
      console.error('Error fetching employee titles:', error)
      throw error
    }
  },

  // Create new employee title
  async createEmployeeTitle(data) {
    try {
      const response = await api.post('/admin/employee-titles', data)
      return response
    } catch (error) {
      console.error('Error creating employee title:', error)
      throw error
    }
  },

  // Update employee title
  async updateEmployeeTitle(id, data) {
    try {
      const response = await api.put(`/admin/employee-titles/${id}`, data)
      return response
    } catch (error) {
      console.error('Error updating employee title:', error)
      throw error
    }
  },

  // Delete employee title
  async deleteEmployeeTitle(id) {
    try {
      const response = await api.delete(`/admin/employee-titles/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting employee title:', error)
      throw error
    }
  }
}

export default employeeTitleService 